var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArsdrejected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.427 3.956v-.508a.412.412 0 0 0-.131-.307L17.287.13A.413.413 0 0 0 16.98 0H4.953a.439.439 0 0 0-.439.439v5.623a4.93 4.93 0 0 0 0 9.825V21.5a.439.439 0 0 0 .44.438h15.035a.44.44 0 0 0 .438-.438V3.956zm-1.026-.438h-2.342V1.14L19.4 3.518zM.883 10.974a4.052 4.052 0 1 1 8.105 0 4.052 4.052 0 0 1-8.105 0zm4.492 10.097v-5.185a4.93 4.93 0 0 0 0-9.824V.877h10.807v3.08a.439.439 0 0 0 .438.438h2.93V21.07H5.375z",
    fill: "#FD3757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.278 12.939a.447.447 0 0 0 .316.132.43.43 0 0 0 .307-.132.438.438 0 0 0 0-.623l-1.342-1.342L6.9 9.632a.44.44 0 0 0-.623-.623l-1.325 1.342-1.36-1.342a.439.439 0 0 0-.622 0 .448.448 0 0 0 0 .623l1.342 1.342-1.342 1.342a.447.447 0 0 0 0 .623.447.447 0 0 0 .316.132.438.438 0 0 0 .307-.132l1.36-1.342 1.324 1.342z",
    fill: "#FD3757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsdrejected);
export default __webpack_public_path__ + "static/media/arsdrejected.0d166f0aebb5038126b62f021b51e193.svg";
export { ForwardRef as ReactComponent };